import { DefaultError, useMutation } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';
import i18next from 'i18next';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IProductContractClearFuture } from './types';

export const useClearContractFuture = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast('useClearContractFuture');
  return useMutation<unknown, DefaultError, IProductContractClearFuture>({
    mutationFn: async body => {
      loading(
        i18next.t('service-message.remove.loading', {
          what: i18next.t('contract-template.contract.what-future'),
        })
      );
      const response = await apiClient({
        method: 'PUT',
        url: 'ProductContract/ClearFuture',
        body,
      });

      return responseHandler(response, {
        groupName: `useClearContractFuture`,
        notFoundPath: '/music-product-digital',
      });
    },
    onSuccess: data => {
      success(
        i18next.t('service-message.remove.success', {
          what: i18next.t('contract-template.contract.what-future'),
        })
      );
    },
    onError: dismiss,
  });
};
